var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BS/Success"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.2441 5.76376C26.3753 4.17119 23.6267 4.17119 21.7579 5.76376L19.4977 7.68992C18.6969 8.37237 17.7012 8.7848 16.6523 8.8685L13.6921 9.10472C11.2446 9.30004 9.30102 11.2436 9.1057 13.6911L8.86947 16.6514C8.78578 17.7002 8.37334 18.6959 7.69089 19.4967L5.76474 21.7569C4.17217 23.6257 4.17217 26.3743 5.76474 28.2431L7.69089 30.5033C8.37334 31.3042 8.78578 32.2999 8.86947 33.3487L9.1057 36.3089C9.30102 38.7565 11.2446 40.7 13.6921 40.8953L16.6523 41.1315C17.7012 41.2152 18.6969 41.6277 19.4977 42.3101L21.7579 44.2363C23.6267 45.8289 26.3753 45.8288 28.2441 44.2363L30.5043 42.3101C31.3051 41.6277 32.3008 41.2152 33.3497 41.1315L36.3099 40.8953C38.7574 40.7 40.701 38.7565 40.8963 36.3089L41.1325 33.3487C41.2162 32.2999 41.6287 31.3042 42.3111 30.5033L44.2373 28.2431C45.8298 26.3743 45.8298 23.6257 44.2373 21.7569L42.3111 19.4967C41.6287 18.6959 41.2162 17.7002 41.1325 16.6514L40.8963 13.6911C40.701 11.2436 38.7574 9.30004 36.3099 9.10472L33.3497 8.8685C32.3008 8.7848 31.3051 8.37237 30.5043 7.68991L28.2441 5.76376ZM25.001 39C32.733 39 39.001 32.732 39.001 25C39.001 17.268 32.733 11 25.001 11C17.269 11 11.001 17.268 11.001 25C11.001 32.732 17.269 39 25.001 39Z",
    fill: "#82BD54"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 234250865",
    d: "M18.6699 23.581L17.2891 24.8836L22.181 31.8663C23.5374 28.36 30.2687 20.0821 32.7147 18.1367H30.2687C27.3019 20.1567 23.6408 24.3175 22.181 26.1455L18.6699 23.581Z",
    fill: "#82BD54"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsSuccess);
export default __webpack_public_path__ + "static/media/bs-success.326d1679675908bd6f1a9ddfe6f020dd.svg";
export { ForwardRef as ReactComponent };